import { css, keyframes } from '@emotion/react';

const rotateGradient = keyframes`
  0% {
    --gradient-angle: 0deg;
  }
  100% {
    --gradient-angle: 360deg;
  }
`;

export const triggerWrapperStyles = (isAnimating: boolean) => css`
  position: relative;
  display: inline-block;

  /* Pseudo-element creates the animated gradient border */
  &::before {
    content: '';
    position: absolute;
    inset: -3px; /* 3px larger on all sides = border width */
    border-radius: var(--radius-round);
    z-index: -1; /* Behind the button */
    box-shadow: 0px 0px var(--shadow-blur-lg, 24px)
      var(--shadow-spread-xs, -4px) rgba(17, 17, 17, 0.1);

    ${isAnimating
      ? css`
          /* Register the custom property */
          @property --gradient-angle {
            syntax: '<angle>';
            initial-value: 0deg;
            inherits: false;
          }

          /* Animated gradient background */
          background: conic-gradient(
            from var(--gradient-angle, 0deg),
            var(--color-primary-600) 0%,
            var(--color-primary-600) 25%,
            var(--color-primary-300) 50%,
            var(--color-primary-600) 75%,
            var(--color-primary-600) 100%
          );
          animation: ${rotateGradient} 3s linear infinite;
        `
      : css`
          /* Static border when not animating */
          background: var(--color-primary-600);
        `}
  }
`;

export const badgeStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--text-primary);
  color: var(--surface-page);
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
  margin-right: var(--spacing-1);
`;

export const buttonOverrideStyles = css`
  background: var(--surface-page);
  border: none;
  border-radius: var(--radius-round);
  padding: var(--spacing-2) var(--spacing-7);
  box-shadow: none;
  color: var(--text-primary);
  font-weight: 700;
  gap: var(--spacing-2);

  &:hover {
    background-color: var(--surface-action-3-hover);
  }

  &:active {
    background-color: var(--surface-action-3-hover);
  }

  &:focus {
    outline-offset: 3px;
  }

  svg {
    color: var(--icon-primary);
  }
`;
